import(/* webpackMode: "eager", webpackExports: ["CookieDeclaration"] */ "/vercel/path0/components/content-blocks/cookie-declaration/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GridCarousel"] */ "/vercel/path0/components/content-blocks/link-list-selection/grid-carousel/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/modules/foundation/components/image/ImageBlock.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/modules/foundation/components/image/ImageFill.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoPlayer"] */ "/vercel/path0/modules/foundation/components/video/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GalleryContainer"] */ "/vercel/path0/modules/page/sanity/content-blocks/gallery-container/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/modules/page/sanity/frontpage/FrontPageDraft.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TabsRootProductList"] */ "/vercel/path0/modules/product/components/tabs/Tabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TabsList","TabsTrigger","TabsContent"] */ "/vercel/path0/node_modules/@radix-ui/react-tabs/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@sanity/next-loader/dist/client-components/live-stream.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@sanity/next-loader/dist/client-components/live.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-sanity/dist/visual-editing/client-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
